/* This file is autogenerated, see readme.md for instructions */
import EllipsisVerticalSvgIcon from '@bloomreach/banana-theme/icons/ellipsis-vertical.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EllipsisVerticalIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EllipsisVerticalSvgIcon />
    </Icon>
  );
});

EllipsisVerticalIcon.displayName = 'EllipsisVerticalIcon';

export default EllipsisVerticalIcon;
